import { createContext } from "react";
export const designThreePagecounter = createContext(null);
export const designThreeMainCategories = createContext([]);
export const designThreeFavoriteInputsArray = createContext( );
export const designThreeWishlistItemsArray = createContext([]);